import React from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderOne from "../components/header/HeaderOne";
import FooterTwo from "../components/footer/FooterTwo";
import Breadcrumb from "./Breadcrumb";
import EmersonHeader from '../components/header/EmersonHeader';
import { useBlogBySlug } from '../services/blogService';

function BlogDetails() {
    const { slug } = useParams();
    
    // Use slug to fetch blog post
    const blogQuery = useBlogBySlug(slug);
    const blogPost = blogQuery.data;
    const loading = blogQuery.isLoading;

    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Blog Details' }
    ];

    if (loading) {
        return (
            <div>
                <EmersonHeader />
                <div className="container text-center py-5">
                    <p>Loading blog post...</p>
                </div>
                <FooterTwo />
            </div>
        );
    }

    if (!blogPost) {
        return (
            <div>
                <EmersonHeader />
                <div className="container text-center py-5">
                    <h2>Blog Post Not Found</h2>
                    <Link to="/blogs" className="rts-btn btn-primary">
                        Back to Blogs
                    </Link>
                </div>
                <FooterTwo />
            </div>
        );
    }
    return (
        <div className=''>

            <EmersonHeader />

            <Breadcrumb title="Blog Details" breadcrumbs={breadcrumbs} />

            {/* rts blog mlist area */}
            <div className="rts-blog-list-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        {/* rts blo post area */}
                        <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            {/* single post */}
                            <div className="blog-single-post-listing details mb--0">
                                {blogPost.bannerImg && (
                                    <div className="thumbnail">
                                        <img 
                                            src={blogPost.bannerImg}
                                            alt={blogPost.title}
                                            style={{ width: '100%', height: '600px', objectFit: 'cover' }} 
                                        />
                                    </div>
                                )}
                                <div className="blog-listing-content">
                                    <h3 className="title">{blogPost.title}</h3>
                                    <div 
                                        className="disc para-1"
                                        dangerouslySetInnerHTML={{ __html: blogPost.description }}
                                    />
                                    {/* quote area start */}
                                    <div className="rts-quote-area text-center">
                                        <h5 className="title">
                                            “We combine technical excellence, global standards knowledge, and innovation to deliver reliable solutions for process monitoring and control.”
                                        </h5>
                                        <Link to={'#'} className="name">
                                            Sembian Research & Engineering
                                        </Link>
                                        <span>Company</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                       
                    </div>
                </div>
            </div>
           


            <FooterTwo />

        </div>
    )
}

export default BlogDetails